import { render } from "./SignUpHeader.vue?vue&type=template&id=4e57d54e&ts=true"
import script from "./SignUpHeader.vue?vue&type=script&lang=ts"
export * from "./SignUpHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn});
